import React, { useState } from 'react';
import { ApprenticeSelector } from '../components/apprentices/ApprenticeSelector';
import { ConfirmButton } from '../components/common/ConfirmButton';
import { todayStr } from '../lib/helpers';

export function TradeSchoolPage({ profile, myApprentices, selApprId, setSelApprId, tradeSchoolLogs, kanganLogs, onAddTS, onDeleteTS, onAddKangan, onDeleteKangan }) {
  const [tab, setTab] = useState('ts');
  const activeId = profile.role === 'apprentice' ? profile.id : selApprId;
  const isApprentice = profile.role === 'apprentice';

  const [tsDate, setTsDate]     = useState(todayStr());
  const [tsHours, setTsHours]   = useState('8');
  const [tsTopic, setTsTopic]   = useState('');
  const [tsSaving, setTsSaving] = useState(false);
  const [tsErr, setTsErr]       = useState('');

  const [kDate, setKDate]         = useState(todayStr());
  const [kNotes, setKNotes]       = useState('');
  const [kTrainer, setKTrainer]   = useState('');
  const [kSaving, setKSaving]     = useState(false);
  const [kErr, setKErr]           = useState('');

  const myTsLogs = tradeSchoolLogs.filter(l => l.apprentice_id === activeId);
  const myKLogs = kanganLogs.filter(l => l.apprentice_id === activeId);
  const totalTsHours = Math.round(myTsLogs.reduce((a, l) => a + Number(l.hours || 0), 0) * 100) / 100;

  async function saveTS() {
    if (!tsHours || isNaN(Number(tsHours)) || Number(tsHours) <= 0) return setTsErr('Enter valid hours.');
    if (!tsTopic.trim()) return setTsErr('Please enter the topic covered.');
    setTsSaving(true); setTsErr('');
    try {
      await onAddTS({ apprentice_id: activeId, log_date: tsDate, hours: Number(tsHours), topic: tsTopic.trim() });
      setTsTopic(''); setTsHours('8');
    } catch (e) { setTsErr(e.message); }
    setTsSaving(false);
  }

  async function saveKangan() {
    if (!kNotes.trim()) return setKErr('Please describe the visit.');
    setKSaving(true); setKErr('');
    try {
      await onAddKangan({ apprentice_id: activeId, visit_date: kDate, notes: kNotes.trim(), trainer_name: kTrainer.trim() || null });
      setKNotes(''); setKTrainer('');
    } catch (e) { setKErr(e.message); }
    setKSaving(false);
  }

  return (
    <div>
      <div className="page-hdr">
        <div>
          <div className="page-title">Trade & Kangan</div>
          <div className="page-sub">Log school attendance and Kangan workplace visits</div>
        </div>
      </div>

      {profile.role !== 'apprentice' && (
        <ApprenticeSelector apprentices={myApprentices} active={selApprId} onChange={setSelApprId} />
      )}

      <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
        <button className={`atab${tab === 'ts' ? ' on' : ''}`} onClick={() => setTab('ts')}>🏫 Trade School</button>
        <button className={`atab${tab === 'k' ? ' on' : ''}`} onClick={() => setTab('k')}>🎓 Kangan Visits</button>
      </div>

      {tab === 'ts' ? (
        <>
          <div className="stats" style={{ gridTemplateColumns: 'repeat(2,1fr)' }}>
            <div className="stat a"><div className="stat-val">{totalTsHours}</div><div className="stat-lbl">Total Hours</div></div>
            <div className="stat b"><div className="stat-val">{myTsLogs.length}</div><div className="stat-lbl">Sessions</div></div>
          </div>

          {isApprentice && (
            <div className="card" style={{ marginBottom: 20 }}>
              <div className="card-hdr"><span className="card-title">Log Hours</span></div>
              <div style={{ padding: 16 }}>
                <div className="frow">
                  <div className="fgrp">
                    <label className="flbl">Date</label>
                    <input className="finp" type="date" value={tsDate} onChange={e => setTsDate(e.target.value)} />
                  </div>
                  <div className="fgrp">
                    <label className="flbl">Hours</label>
                    <input className="finp" type="number" min="0.5" step="0.5" value={tsHours} onChange={e => setTsHours(e.target.value)} />
                  </div>
                </div>
                <div className="fgrp">
                  <label className="flbl">Topic Covered</label>
                  <textarea className="ftxt" value={tsTopic} onChange={e => setTsTopic(e.target.value)} placeholder="What was covered in class?" />
                </div>
                {tsErr && <div className="err">{tsErr}</div>}
                <button className="btn" onClick={saveTS} disabled={tsSaving}>{tsSaving ? 'Saving…' : 'Log Hours'}</button>
              </div>
            </div>
          )}

          <div className="card">
            <div className="card-hdr"><span className="card-title">History ({myTsLogs.length})</span></div>
            <div className="table-wrap">
              <table>
                <thead><tr><th>Date</th><th>Hours</th><th>Topic</th>{isApprentice && <th></th>}</tr></thead>
                <tbody>
                  {myTsLogs.length === 0 ? (
                    <tr><td colSpan={isApprentice ? 4 : 3} style={{ textAlign: 'center', color: 'var(--muted)', padding: 30 }}>No entries yet</td></tr>
                  ) : myTsLogs.map(l => (
                    <tr key={l.id}>
                      <td>{l.log_date}</td>
                      <td>{Math.round(l.hours * 100) / 100}h</td>
                      <td>{l.topic}</td>
                      {isApprentice && (
                        <td><ConfirmButton onConfirm={() => onDeleteTS(l.id)} label="×" confirmLabel="Sure?" /></td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </>
      ) : (
        <>
          {isApprentice && (
            <div className="card" style={{ marginBottom: 20 }}>
              <div className="card-hdr"><span className="card-title">Log Kangan Visit</span></div>
              <div style={{ padding: 16 }}>
                <div className="frow">
                  <div className="fgrp">
                    <label className="flbl">Visit Date</label>
                    <input className="finp" type="date" value={kDate} onChange={e => setKDate(e.target.value)} />
                  </div>
                  <div className="fgrp">
                    <label className="flbl">Kangan Trainer Name</label>
                    <input className="finp" value={kTrainer} onChange={e => setKTrainer(e.target.value)} placeholder="e.g. John Smith" />
                  </div>
                </div>
                <div className="fgrp">
                  <label className="flbl">Visit Notes</label>
                  <textarea className="ftxt" value={kNotes} onChange={e => setKNotes(e.target.value)} placeholder="What was discussed / assessed?" />
                </div>
                {kErr && <div className="err">{kErr}</div>}
                <button className="btn" onClick={saveKangan} disabled={kSaving}>{kSaving ? 'Saving…' : 'Log Visit'}</button>
              </div>
            </div>
          )}

          <div className="card">
            <div className="card-hdr"><span className="card-title">Visit History ({myKLogs.length})</span></div>
            <div className="table-wrap">
              <table>
                <thead><tr><th>Date</th><th>Trainer</th><th>Notes</th>{isApprentice && <th></th>}</tr></thead>
                <tbody>
                  {myKLogs.length === 0 ? (
                    <tr><td colSpan={isApprentice ? 4 : 3} style={{ textAlign: 'center', color: 'var(--muted)', padding: 30 }}>No visits logged</td></tr>
                  ) : myKLogs.map(l => (
                    <tr key={l.id}>
                      <td>{l.visit_date}</td>
                      <td>{l.trainer_name || '—'}</td>
                      <td>{l.notes}</td>
                      {isApprentice && (
                        <td><ConfirmButton onConfirm={() => onDeleteKangan(l.id)} label="×" confirmLabel="Sure?" /></td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
